/* eslint-disable react-hooks/exhaustive-deps */
import { useIsFocused, useNavigation } from "@react-navigation/native";

import React, { useCallback, useEffect, useMemo, useState } from "react";

import Image from "@components/common/Image";
import Text from "@components/CustomText";
import OrderCancelReasonsModal from "@components/OrderCancelReasonsModal";
import OrderCancelSuccessModal from "@components/OrderCancelSuccessModal";
import testIds from "@constants/testIds";
import {
  ActivityIndicator,
  BackHandler,
  FlatList,
  Pressable,
  ScrollView,
  StyleSheet,
  TouchableNativeFeedback,
  View,
} from "react-native";
import { useDispatch, useSelector } from "react-redux";
import ExclaimSymbol from "@assets/svg/ExclaimSymbol";
import ToastMessage from "@components/Toast";
import { MY_ORDERS_EVENTS } from "@constants/analyticsEventsCT";
import colors from "@constants/color";
// eslint-disable-next-line import/no-named-as-default
import t from "@constants/localization";
import metrics from "@constants/metrics";
import useFocusAndAppState from "@hooks/useFocusAndAppState";
import analytics from "@services/analytics";
import { fontFamily } from "@utils/styles";
import debounce from "lodash/debounce";
import BackArrow from "../../assets/svg/BackArrow";
import OrderStatus from "../../assets/svg/OrderStatus";
import { actions as miscActions } from "../../reducers/miscReducer";
import { actions } from "../../reducers/orderReducer";
import { actions as rrdActions } from "../../reducers/rrdReducer";

import {
  cancelOrder,
  getOrderDetailByIdV2,
  getRvpOrderDetails,
  returnRequestCancelV2,
} from "../../services/api";
import CustomModal from "../OrdersList/CustomModal";
import SeeReturnModal from "./SeeReturnModal";

const PATH = "screens/OrderDetails/index";

function OrderItem(props) {
  const [visible, setVisible] = useState(false);
  const [seeReturnData, setSeeReturnData] = useState([]);
  const {
    item_list_status = "",
    item_list_status_icon = "",
    item_list_status_color = "",
    items = [],
    edd = null,
    delivered_at = "",
    cancelled_at = "",
    navigateToProductDetails = () => {},
    rvpData = [],
    status,
    orderData = {},
    cpDbId = "",
    navigateToSelectedProduct = () => {},
    setRefetch = () => {},
  } = props;

  function getOrderDetailsMerged() {
    const merged = [];
    items.forEach((item) => {
      const rvpItem = rvpData.find((rvp) => rvp.order_item_id === item.id);
      merged.push({
        ...item,
        has_active_cx_rto: rvpItem?.has_active_cx_rto,
        return_window_days: rvpItem?.return_window_days,
        enable_return: rvpItem?.enable_return,
        return_time_text: rvpItem?.return_time_text,
        replace_time_text: rvpItem?.replace_time_text,
        return_window_expired_text: rvpItem?.return_window_expired_text,
      });
    });
    return merged;
  }

  const mergedItems = useMemo(() => {
    return getOrderDetailsMerged(items, rvpData);
  }, [items, rvpData]);

  const datePrefix = edd
    ? t(`${PATH}/deliveryDate`)
    : delivered_at
      ? t(`${PATH}/delivered`)
      : cancelled_at
        ? t(`${PATH}/cancellationDate`)
        : "";
  const date = edd || delivered_at || cancelled_at || "";

  const seeReturn = ({ returnRequests }) => {
    setSeeReturnData(returnRequests);
    setVisible(true);
  };

  const shouldShowReturnDekhein = (item) => {
    const singleRvpData = rvpData.find((rvp) => rvp.order_item_id === item.id);
    return (
      (Array.isArray(item?.returnRequests) &&
        item?.returnRequests.length &&
        (status === "RETURNED" || !singleRvpData?.enable_return)) ||
      false
    );
  };

  return (
    <View style={styles.orderItemContainer}>
      <View style={styles.orderItemHeader}>
        <View style={styles.orderItemStatusRow}>
          <OrderStatus
            orderStatus={
              orderData?.cx_rto_details?.agg_status_icon ||
              item_list_status_icon
            }
            testID={testIds.order_satus}
          />
          <Text
            variant="body_text_4"
            style={[
              styles.orderItemStatusText,
              {
                color:
                  orderData?.cx_rto_details?.cx_rto_status_color ||
                  item_list_status_color,
              },
            ]}
          >
            {orderData?.cx_rto_details?.cx_rto_status_text || item_list_status}
          </Text>
        </View>
        {!orderData?.cx_rto_details?.cx_rto_status_text ? (
          <View style={styles.dateContainer}>
            <Text style={styles.datePrefixText}>
              {datePrefix} <Text style={styles.dateBoldText}>{date}</Text>
            </Text>
          </View>
        ) : null}
      </View>
      <View style={styles.orderItemDivider} />
      <View style={styles.orderItemsList}>
        {mergedItems.map((i, index) => (
          <Pressable
            onPress={() => navigateToProductDetails(i.slug)}
            key={`key-${i.text}-${i.name}-${index}`}
            testID={`${testIds.product_no_}${index}`}
          >
            <View style={styles.productRow}>
              <Image
                source={{ uri: i.product_image ? i.product_image : "" }}
                resizeMode={Image.resizeMode.contain}
                style={styles.productImage}
              />
              <View style={styles.productDetails}>
                <View style={styles.productNameRow}>
                  <Text
                    ellipsizeMode="tail"
                    numberOfLines={1}
                    variant="body_text_3"
                    style={styles.productName}
                  >
                    {i.name}
                  </Text>
                </View>
                <View style={styles.qtyRow}>
                  <Text style={styles.qtyText}>
                    Qty: <Text style={styles.qtyValue}>{i.quantity}</Text>
                  </Text>
                </View>
                {i.disputed_tags && Array.isArray(i.disputed_tags) ? (
                  <View style={styles.disputedTagsContainer}>
                    {i.disputed_tags.map((tag) => (
                      <View key={tag} style={styles.disputedTag}>
                        <Text
                          variant="caption_2"
                          style={styles.disputedTagText}
                        >
                          {tag}
                        </Text>
                      </View>
                    ))}
                  </View>
                ) : null}
                <View style={styles.returnActionsRow}>
                  {orderData?.cx_rto_details ? (
                    <View style={styles.cxRtoReturnBadge}>
                      <Text style={styles.cxRtoReturnText}>रिटर्न</Text>
                    </View>
                  ) : null}
                  {i.enable_return && !cpDbId ? (
                    <View style={styles.returnColumnEnd}>
                      <Pressable
                        onPress={() =>
                          navigateToSelectedProduct(
                            rvpData.find((rvp) => rvp.order_item_id === i.id),
                          )
                        }
                        style={styles.rtnBtnCon}
                      >
                        <Text style={styles.rtnTxt}>रिटर्न</Text>
                      </Pressable>
                      {i.return_time_text || i.replace_time_text ? (
                        <View style={styles.remainingTextContainer}>
                          <ExclaimSymbol fill="rgba(0, 0, 0, 0.36)" />
                          <Text style={styles.remainingText}>
                            {i.return_time_text || i.replace_time_text}
                          </Text>
                        </View>
                      ) : null}
                    </View>
                  ) : null}
                  {shouldShowReturnDekhein(i) ? (
                    <View style={styles.returnColumnEnd}>
                      <Pressable
                        onPress={() =>
                          seeReturn({ returnRequests: i?.returnRequests })
                        }
                        style={styles.rtnBtnCon}
                      >
                        <Text style={styles.rtnTxt}>रिटर्न देखें </Text>
                      </Pressable>
                    </View>
                  ) : null}
                </View>
              </View>
            </View>
            {i.return_window_expired_text && status !== "RETURNED" ? (
              <View style={styles.expiredTextRow}>
                <ExclaimSymbol fill="rgba(0, 0, 0, 0.36)" />
                <Text style={styles.remainingText}>
                  {i.return_window_expired_text}{" "}
                </Text>
              </View>
            ) : null}
            <View style={styles.itemDivider} />
          </Pressable>
        ))}
      </View>
      <SeeReturnModal
        visible={visible}
        setVisible={setVisible}
        setRefetch={setRefetch}
        data={seeReturnData}
      />
    </View>
  );
}

const OrderDetails = ({ route }) => {
  const { params = {} } = route;
  const {
    goBackScreenName = "",
    order_id = "",
    fromDeclarationSubmit = false,
  } = params;
  const navigation = useNavigation();
  const dispatch = useDispatch();
  const [data, setData] = useState({});
  const [rvpDetails, setrvpDetails] = useState([]);
  const [refetch, setRefetch] = useState(false);
  const [cancelModal, setCancelModal] = useState(false);
  const {
    selectedOrder = null,
    cancellationReasons = [],
    isVacationOrder = false,
    source = "FORWARD",
  } = useSelector((s) => s.orders);
  const { cp_db_id = "" } = useSelector((s) => s.auth.user);

  const { toggleOrderDetailsRefetch } = useSelector((s) => s.misc);
  const [reasonsModalVisible, setReasonsModalVisible] = useState(false);
  const [selectedReasonIndex, setSelectedReasonIndex] = useState(null);
  const [hasOrderCancelled, setHasOrderCancelled] = useState(false);
  const [fetchComplete, setFetchComplete] = useState(false);
  const isFocused = useIsFocused();

  useEffect(() => {
    if (isFocused && fromDeclarationSubmit) {
      setRefetch((r) => !r);
    }
  }, [isFocused]);
  const navigateToProductDetails = (slug) => {
    navigation.navigate("ProductDetails", { slug });
  };

  const backhandler = useCallback(() => {
    if (goBackScreenName) {
      navigation.navigate(goBackScreenName);
    } else {
      navigation.goBack();
    }
    return true;
  }, [goBackScreenName, navigation]);

  const onCancelOrder = () => {
    const payload = {
      orderId: data.order_id,
      cancellationReason: selectedReasonIndex,
    };
    cancelOrder(payload)
      .then(({ data: cancelledOrderData }) => {
        setHasOrderCancelled(!!cancelledOrderData.cancelled);
        setReasonsModalVisible(false);
        setSelectedReasonIndex(null);
        setRefetch((r) => !r);
        dispatch(miscActions.showOrderCancelSuccessModal());
        analytics.trackEvent(MY_ORDERS_EVENTS.ORDER_CANCEL, {
          order_id: data?.order_id || "",
        });
      })
      // eslint-disable-next-line no-console
      .catch((error) => console.log(error));
  };
  const cancelReturnRequest = async () => {
    try {
      const { data: res } = await returnRequestCancelV2({
        return_req_id: data?.cx_rto_details?.return_req_id,
        type: data?.cx_rto_details?.type ?? "cx_rto",
      });
      dispatch(rrdActions.fetchRRDInfo());
      setFetchComplete(false);
      setRefetch((r) => !r);
      ToastMessage("success", res?.message);
    } catch (e) {
      // eslint-disable-next-line no-console
      console.log(e);
    }
  };

  useEffect(() => {
    const subscription = BackHandler.addEventListener("hardwareBackPress", backhandler);
    return () => {
      subscription.remove();
    };
  }, [backhandler]);

  const fetchOrderData = useCallback(
    debounce(async () => {
      try {
        const { data: response } = await getOrderDetailByIdV2({
          orderId: order_id || selectedOrder,
          isVacationOrder,
          source,
        });
        const orderId = order_id || selectedOrder;
        const { data: rvpData } = await getRvpOrderDetails(orderId);
        dispatch(actions.fetchCancellationReasonsRequest());
        setData(response);
        setFetchComplete(true);

        const rvpDataFilter = rvpData?.items?.filter(
          // eslint-disable-next-line eqeqeq
          (rvp) => rvp.parent_order == orderId,
        );

        if (Array.isArray(rvpDataFilter) && rvpDataFilter.length) {
          setrvpDetails({
            cx_delivery: rvpData.cx_delivery,
            items: rvpDataFilter,
          });
        }
      } catch (e) {
        // eslint-disable-next-line no-console
        console.log(e);
      }
    }, 500),
    [selectedOrder, dispatch, order_id, refetch, toggleOrderDetailsRefetch],
  );

  useFocusAndAppState(fetchOrderData, fetchOrderData);

  const navigateToSelectedProduct = (rvpData) => {
    navigation.navigate("SelectProduct", {
      rvpData,
    });
  };

  const renderItem = ({ item }) => (
    <OrderItem
      {...item}
      rvpData={rvpDetails?.items}
      key={item.order_id}
      navigateToProductDetails={navigateToProductDetails}
      orderData={data}
      cpDbId={cp_db_id}
      navigateToSelectedProduct={navigateToSelectedProduct}
      setRefetch={setRefetch}
    />
  );

  const arrayItems = data?.cx_rto_details
    ? data?.refundDetails
    : data?.priceDetails;

  const renderHeaderComponent = useCallback(() => {
    return (
      <ScrollView testID={testIds.order_scroll_view}>
        <View style={styles.orderSummary}>
          <View style={styles.topContainer}>
            <View style={styles.orderIdContainer}>
              <Text variant="body_text_3" style={styles.labelText}>
                {t(`${PATH}/orderNo`)}
              </Text>
              <Text style={styles.orderIdText}>{data?.order_id ?? ""}</Text>
            </View>
            <View style={styles.dateAlignEnd}>
              <Text variant="body_text_3" style={styles.labelText}>
                {t(`${PATH}/orderDate`)}
              </Text>
              <Text variant="body_text_3" style={styles.dateValueText}>
                {` ${data?.created_at.trim() ?? ""}`}
              </Text>
            </View>
          </View>
          <View style={styles.personalInfoWrapper}>
            <View style={styles.personalInfo}>
              <View style={styles.userNameRow}>
                <Text variant="subtitle_16">{data?.user_name ?? ""}</Text>
              </View>

              <Text variant="caption_2" style={styles.phone}>
                +91 - {data?.user_phone ?? ""}
              </Text>
              {data?.user_address && (
                <Text variant="caption_2" style={styles.address}>
                  {data?.user_address ?? ""}
                </Text>
              )}
            </View>
          </View>

          {data?.plastic_bag_opted_in &&
            data?.priceDetails?.plasticBagCount > 0 && (
              <View style={styles.plasticBagBanner}>
                <Text variant="body_text_2" style={styles.plasticBagText}>
                  {`${data.priceDetails.plasticBagCount} पॉली बैग ज़रूरी। कृपया इस ऑर्डर को पॉली बैग में डिलीवर करें।`}
                </Text>
              </View>
            )}
          <View style={styles.hr} />
          <View style={styles.priceDetails} testId={testIds.price_detail}>
            <Text variant="subtitle_16" style={styles.priceDetailsHeader}>
              {t(`${PATH}/priceDetails`)}
            </Text>
            {arrayItems &&
              arrayItems.map((i) => (
                /* eslint-disable react-native/no-inline-styles, react-native/no-color-literals */
                <View style={styles.priceRow} key={`${i.amount}${i.text}`}>
                  <Text
                    style={[
                      styles.priceItemText,
                      {
                        fontFamily: i.bold
                          ? "NotoSansDevanagari-Bold"
                          : "NotoSansDevanagari-Regular",
                      },
                    ]}
                  >
                    {i?.text?.trim() || ""}
                  </Text>
                  <Text
                    style={[
                      styles.priceAmountText,
                      {
                        fontFamily:
                          i.bold || i.amount.trim() === "FREE"
                            ? "NotoSansDevanagari-Bold"
                            : "NotoSansDevanagari-Regular",
                        color: i.amountGreen ? "#27AE60" : colors.black,
                      },
                    ]}
                  >
                    {i?.amount?.trim() || ""}
                  </Text>
                </View>
                /* eslint-enable react-native/no-inline-styles, react-native/no-color-literals */
              ))}
            {data?.show_refundable_amount ? (
              <Text style={styles.refundableText}>
                <Text style={styles.refundableBold}>
                  ₹{data.refundable_amount}
                </Text>{" "}
                {t(`${PATH}/willBeRefunded`)}
              </Text>
            ) : null}
          </View>
        </View>
      </ScrollView>
    );
  }, [data, rvpDetails, arrayItems]);

  return !fetchComplete ? (
    <View style={styles.loadingContainer}>
      <ActivityIndicator />
    </View>
  ) : (
    <View style={styles.flex1}>
      <View style={styles.header}>
        <TouchableNativeFeedback
          style={styles.backBtnTouchable}
          onPress={backhandler}
        >
          <BackArrow style={styles.backArrow} />
        </TouchableNativeFeedback>
        <View style={styles.headerInner}>
          <CustomModal
            heading={
              data?.cx_rto_details?.cancel_confirmation_modal_info?.heading
            }
            visible={cancelModal}
            fontFamily={false}
            headingFontWeight="bold"
            onPress={cancelReturnRequest}
            message={
              data?.cx_rto_details?.cancel_confirmation_modal_info?.message
            }
            setShowModal={() => {
              setCancelModal(false);
            }}
            buttons={
              data?.cx_rto_details?.cancel_confirmation_modal_info
                ?.cancel_confirm_options
            }
          />
          <Text variant="title_18" style={styles.headerTitle}>
            {`${t(`${PATH}/order`)} - ${data?.order_id ?? ""}`}
          </Text>
          {data?.cancellable ? (
            <TouchableNativeFeedback
              onPress={() => {
                setReasonsModalVisible(true);
              }}
              style={styles.cancelBtnTouchable}
            >
              <Text variant="body_text_4" style={styles.cancelBtnText}>
                {t(`${PATH}/cancelOrder`)}
              </Text>
            </TouchableNativeFeedback>
          ) : (
            <></>
          )}
        </View>
      </View>
      <FlatList
        data={data?.itemLists}
        // contentContainerStyle={{ paddingBottom: 30 }}
        keyExtractor={(item, index) => index.toString()}
        // ListFooterComponent={() => (
        //   <DeliveryTimeline orderId={data?.order_id ?? ""} />
        // )}
        ListHeaderComponent={renderHeaderComponent}
        renderItem={renderItem}
      />
      <OrderCancelReasonsModal
        shouldShowModal={reasonsModalVisible}
        handleModalClose={() => setReasonsModalVisible(false)}
        reasons={cancellationReasons}
        setSelectedReason={(reason) => {
          setSelectedReasonIndex(reason);
        }}
        selectedReasonIndex={selectedReasonIndex}
        onCancelOrder={onCancelOrder}
        fromScreen="OrderDetails"
      />
      <OrderCancelSuccessModal
        hasOrderCancelled={hasOrderCancelled}
        fromScreen="OrderDetails"
        cancellationReason={selectedReasonIndex}
      />
    </View>
  );
};

const OD_PALETTE = {
  white: "white",
  sectionBg: "rgba(0, 0, 0, 0.05)",
  dividerColor: "rgba(0, 0, 0, 0.1)",
  itemContainerBorderColor: "rgba(0,0,0,0.05)",
  itemDividerColor: "rgba(0,0,0,0.1)",
  remainingTextColor: "rgba(0, 0, 0, 0.56)",
  dateTextColor: "rgba(0, 0, 0, 0.86)",
  productNameColor: "rgba(0,0,0,0.86)",
  rtnBtnBorder: "rgba(0, 0, 0, 0.2)",
  plasticBannerBg: "#FFF9E6",
  plasticBannerText: "#B45309",
  cancelBtnColor: "#E40046",
  amountGreenColor: "#27AE60",
  disputedTagBg: "rgba(255, 46, 0, 0.10)",
  disputedTagText: "rgba(255, 46, 0, 1)",
  cxRtoBadgeBg: "rgba(255, 46, 0, 0.1)",
  cxRtoBorderColor: "#FF2E00",
  cxRtoTextColor: "#FF2E00",
};

const styles = StyleSheet.create({
  flex1: {
    flex: 1,
  },
  loadingContainer: {
    flex: 1,
    justifyContent: "center",
    alignItems: "center",
  },
  header: {
    backgroundColor: OD_PALETTE.white,
    flexDirection: "row",
    minHeight: 56,
    elevation: 1,
  },
  backBtnTouchable: {
    paddingRight: 15,
    paddingVertical: 10,
    marginLeft: 10,
  },
  backArrow: {
    margin: 20,
  },
  headerInner: {
    alignItems: "center",
    flexDirection: "row",
    justifyContent: "space-between",
    flex: 1,
  },
  headerTitle: {
    color: colors.mediumBlack,
    alignSelf: "center",
    marginRight: "auto",
    fontFamily: "NotoSansDevanagari-SemiBold",
    marginTop: 4,
    maxWidth: "70%",
  },
  cancelBtnTouchable: {
    marginLeft: "auto",
  },
  cancelBtnText: {
    alignSelf: "center",
    color: OD_PALETTE.cancelBtnColor,
    paddingVertical: 10,
    paddingRight: 15,
  },
  orderSummary: {
    flexDirection: "column",
    paddingTop: 20,
    backgroundColor: OD_PALETTE.white,
  },
  topContainer: {
    flex: 1,
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    paddingHorizontal: 15,
  },
  orderIdContainer: {
    flex: 1,
  },
  labelText: {
    color: colors.lightBlack,
    marginBottom: 4,
  },
  orderIdText: {
    fontWeight: "bold",
    color: OD_PALETTE.white,
  },
  dateAlignEnd: {
    alignItems: "flex-end",
  },
  dateValueText: {
    color: OD_PALETTE.white,
  },
  personalInfoWrapper: {
    paddingHorizontal: 15,
  },
  personalInfo: {
    backgroundColor: OD_PALETTE.sectionBg,
    padding: 10,
    borderRadius: 10,
    marginTop: 20,
  },
  userNameRow: {
    flexDirection: "row",
    justifyContent: "space-between",
  },
  phone: {
    color: colors.lightBlack,
  },
  address: {
    opacity: 0.86,
    paddingTop: 2,
  },
  plasticBagBanner: {
    paddingHorizontal: 16,
    paddingVertical: 8,
    backgroundColor: OD_PALETTE.plasticBannerBg,
    marginHorizontal: 16,
    borderRadius: 6,
    marginBottom: 8,
  },
  plasticBagText: {
    color: OD_PALETTE.plasticBannerText,
  },
  hr: {
    width: "120%",
    height: 1,
    backgroundColor: OD_PALETTE.dividerColor,
    marginTop: 12,
    marginLeft: -15,
  },
  priceDetails: {
    paddingHorizontal: 15,
  },
  priceDetailsHeader: {
    marginTop: 15,
  },
  priceRow: {
    flexDirection: "row",
    justifyContent: "space-between",
    marginVertical: 3,
  },
  priceItemText: {
    fontSize: 14,
    opacity: 0.86,
  },
  priceAmountText: {
    fontSize: 14,
  },
  refundableText: {
    color: colors.lightBlack,
    paddingVertical: 10,
  },
  refundableBold: {
    fontWeight: "bold",
  },
  remainingText: {
    color: OD_PALETTE.remainingTextColor,
    marginLeft: 5,
    marginRight: 2,
    fontStyle: "italic",
  },
  remainingTextContainer: {
    flexDirection: "row",
    marginTop: 7,
  },
  rtnBtnCon: {
    width: 95,
    height: 30,
    backgroundColor: OD_PALETTE.white,
    borderRadius: 6,
    borderWidth: 1,
    borderColor: OD_PALETTE.rtnBtnBorder,
    justifyContent: "center",
    alignItems: "center",
  },
  rtnTxt: {
    fontSize: 12,
    fontFamily: fontFamily.semiBold,
  },
  orderItemContainer: {
    backgroundColor: OD_PALETTE.white,
    borderBottomColor: OD_PALETTE.itemContainerBorderColor,
  },
  orderItemHeader: {
    flexDirection: "row",
    justifyContent: "space-between",
    paddingHorizontal: 15,
    marginVertical: 5,
    alignItems: "center",
    paddingVertical: 5,
  },
  orderItemStatusRow: {
    flexDirection: "row",
  },
  orderItemStatusText: {
    marginLeft: 6,
    marginTop: 1,
  },
  dateContainer: {
    alignItems: "flex-end",
    justifyContent: "center",
  },
  datePrefixText: {
    color: OD_PALETTE.remainingTextColor,
    fontFamily: "NotoSansDevanagari-Regular",
    fontSize: 12,
    lineHeight: 16,
    marginTop: 2,
  },
  dateBoldText: {
    color: OD_PALETTE.dateTextColor,
    fontFamily: "NotoSansDevanagari-Bold",
  },
  orderItemDivider: {
    backgroundColor: OD_PALETTE.dividerColor,
    height: 1,
    marginHorizontal: 15,
  },
  orderItemsList: {
    paddingHorizontal: 15,
  },
  productRow: {
    paddingVertical: 15,
    flexDirection: "row",
  },
  productImage: {
    height: 100,
    width: 100,
    marginRight: 10,
  },
  productDetails: {
    flex: 1,
  },
  productNameRow: {
    flexDirection: "row",
  },
  productName: {
    marginBottom: 8,
    color: OD_PALETTE.productNameColor,
    flex: 1,
    flexWrap: "wrap",
  },
  qtyRow: {
    flexDirection: "row",
    alignItems: "center",
  },
  qtyText: {
    fontSize: 12,
    lineHeight: 16,
    fontFamily: "NotoSansDevanagari-Regular",
    color: OD_PALETTE.remainingTextColor,
  },
  qtyValue: {
    color: OD_PALETTE.white,
  },
  disputedTagsContainer: {
    alignItems: "flex-start",
    justifyContent: "flex-start",
  },
  disputedTag: {
    backgroundColor: OD_PALETTE.disputedTagBg,
    borderRadius: 20,
    paddingHorizontal: 8,
    paddingVertical: 2,
    marginVertical: 4,
    marginRight: 4,
  },
  disputedTagText: {
    color: OD_PALETTE.disputedTagText,
    lineHeight: 18,
  },
  returnActionsRow: {
    flexDirection: "row",
    justifyContent: "space-between",
    marginTop: 10,
    alignItems: "center",
  },
  cxRtoReturnBadge: {
    backgroundColor: OD_PALETTE.cxRtoBadgeBg,
    paddingTop: 6,
    paddingHorizontal: 30,
    alignItems: "center",
    justifyContent: "center",
    borderRadius: 4,
    borderColor: OD_PALETTE.cxRtoBorderColor,
    borderWidth: 1,
  },
  cxRtoReturnText: {
    color: OD_PALETTE.cxRtoTextColor,
  },
  returnColumnEnd: {
    flexDirection: "column",
    alignItems: "flex-end",
  },
  expiredTextRow: {
    flexDirection: "row",
    marginBottom: 10,
  },
  itemDivider: {
    borderBottomColor: OD_PALETTE.itemDividerColor,
    borderBottomWidth: 1,
    width: metrics.screenWidth,
    marginLeft: -15,
  },
});

export default OrderDetails;
